import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import Layout from "../components/Layout";
import Stage from "../components/Stage/Stage";
import ProcessSteps from "../components/ProcessSteps/ProcessSteps";
import Container from "../components/share/Container/Container";
import Button from "../components/share/Button/Button";
import "./poolbau-page.scss";

export const PoolbauPageTemplate = ({
  title,
  image,
  description,
  steps
}) => {
  return (
    <div className="PoolbauPage">
      <div className="PoolbauPage__stage">
        <Stage title={title} image={image} />
      </div>
      <section className="PoolbauPage__intro">
        <Container variant="no-top">
          <div className="PoolbauIntro">
            <span className="PoolbauIntro__eyebrow">Hannover &amp; Region</span>
            <p className="PoolbauIntro__text">{description}</p>
          </div>
        </Container>
      </section>
      <ProcessSteps steps={steps} />
      <div className="PoolbauPage__cta">
        <Container variant="no-top">
          <Button variant="dark" link="/contact" label="Kontakt aufnehmen & Poolprojekt starten" />
        </Container>
      </div>
    </div>
  );
};

PoolbauPageTemplate.propTypes = {
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.string,
  description: PropTypes.string,
  steps: PropTypes.array,
};

const PoolbauPage = ({ data, location }) => {
  const { frontmatter } = data.markdownRemark;

  return (
    <Layout pageTitle={frontmatter.metaTitle} pageDescription={frontmatter.metaDescription} pagePath={location && location.pathname}>
      <PoolbauPageTemplate
        image={frontmatter.image}
        title={frontmatter.title}
        description={frontmatter.description}
        steps={frontmatter.steps}
      />
    </Layout>
  );
};

PoolbauPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
};

export default PoolbauPage;

export const PoolbauPageQuery = graphql`
  query PoolbauPage {
    markdownRemark(frontmatter: { templateKey: { eq: "poolbau-page" } }) {
      frontmatter {
        title
        image {
          childImageSharp {
            gatsbyImageData(
              placeholder: BLURRED
              formats: [AUTO, WEBP]
              width: 2000
              breakpoints: [480, 568, 800, 1024, 1280]
              quality: 100
            )
          }
        }
        description
        steps {
          text
          description
          image {
            childImageSharp {
              gatsbyImageData(
                placeholder: BLURRED
                formats: [AUTO, WEBP]
                width: 1000
                breakpoints: [480, 568, 800, 1024, 1280]
                quality: 90
              )
            }
          }
        }
        metaTitle
        metaDescription
      }
    }
  }
`;
